import Page from "../common/page";

export default class PageGuide extends Page {

}
